import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

type RoleProps = {
  roleInfo: any
}

const initialState = {
  roleInfo: {},
} as RoleProps

// const root = 'http://mock.ixiaochuan.cn/mock/412'
export const getRoleInfo = createAsyncThunk<any, any>(
  'getRoleInfo',
  async (arg, store) => {
    return req(
      '/xai_get_role_display_info',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

// const root = 'http://mock.ixiaochuan.cn/mock/412'
export const readInfo = createAsyncThunk<any, any>(
  'readInfo',
  async (arg, store) => {
    return req(
      '/xai_role_info_read',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

// const root = 'http://mock.ixiaochuan.cn/project/412/interface/api/23403'
export const getMemeryList = createAsyncThunk<any, any>(
  'getMemeryList',
  async (arg, store) => {
    return req(
      '/xai_search_remember',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

// const root = 'http://mock.ixiaochuan.cn/project/412/interface/api/23403'
export const deleteMemery = createAsyncThunk<any, any>(
  'deleteMemery',
  async (arg, store) => {
    return req(
      '/xai_delete_remember',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

// const root = 'http://mock.ixiaochuan.cn/project/412/interface/api/23558'
export const getRelationList = createAsyncThunk<any, any>(
  'getRelationList',
  async (arg, store) => {
    return req(
      '/xai_get_role_relationship',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const sendH5 = createAsyncThunk<any, any>(
  'sendH5',
  async (arg, store) => {
    return req(
      '/character/get_relationship_list',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      null
    )
  }
)

export const getReviewFailDetail = createAsyncThunk<any, any>(
  'getReviewFailDetail',
  async (arg, store) => {
    return req(
      '/character/get_private_role_audit',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      null
    )
  }
)

export const getUserBondLevel = createAsyncThunk<any, any>(
  'getUserBondLevel',
  async (arg, store) => {
    return req(
      '/character/get_user_character_bond_level',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      null
    )
  }
)

export const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoleInfo.fulfilled, (state, action) => {
      return {
        ...state,
        roleInfo: action.payload,
      }
    })
  },
})

export default roleSlice.reducer
